export const FamilyRanksConsts = ["PARENT", "GRANDPARENT", "CHILD"];
//# sourceMappingURL=Family.js.map